export const AppId = 101; //Appid 1 for admin